export default function localizedTitle(config, i18n) {
  if (!config) return '';

  const parseMaybeJson = (value) => {
    if (typeof value !== 'string') return value;

    let parsed = value;
    for (let i = 0; i < 2; i += 1) {
      if (typeof parsed !== 'string') break;
      const trimmed = parsed.trim();
      if (!trimmed.startsWith('{') && !trimmed.startsWith('"')) break;

      try {
        parsed = JSON.parse(trimmed);
      } catch (error) {
        break;
      }
    }

    return parsed;
  };

  const resolve = (value) => {
    const tv = parseMaybeJson(value);
    if (tv && typeof tv === 'object') {
      return tv[i18n?.language] || tv.fr || tv.en || '';
    }
    return tv || '';
  };

  const customTitle = resolve(config.custom_title);
  if (customTitle) return customTitle;

  const tv = parseMaybeJson(config.title);
  if (tv && typeof tv === 'object') {
    return tv[i18n?.language] || tv.fr || tv.en || JSON.stringify(tv);
  }
  return tv || '';
}
